<template>
    <ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery" :filters="false">
        <template slot="btns" v-if="permission('/content/question/add')">
            <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd">新增常见问题</el-button>
        </template>
        <template slot="columns">
            <el-table-column type="index" label="序号" width="100" align="center" />
            <el-table-column label="标题" align="center" prop="title"></el-table-column>
            <el-table-column label="标题（英文）" align="center" prop="enTitle"></el-table-column>
            <el-table-column label="权重" align="center" prop="weight"></el-table-column>
            <el-table-column label="创建时间" align="center" prop="createTime"></el-table-column>
            <el-table-column label="操作" align="center" width="180"
                v-if="permission('/content/question/detail') || permission('/content/question/edit') || permission('/content/question/delete')">
                <template slot-scope="{ row }">
                    <el-link v-if="permission('/content/question/detail')" :underline="false" type="primary"
                        @click="handleEdit(row)">
                        查看详情
                    </el-link>
                    <el-link v-if="permission('/content/question/edit')" :underline="false" type="primary"
                        @click="handleEdit(row)">
                        编辑
                    </el-link>
                    <el-link v-if="permission('/content/question/delete')" :underline="false" type="danger"
                        @click="handleDelete(row)">
                        删除
                    </el-link>
                </template>
            </el-table-column>
        </template>
    </ListPage>
</template>

<script>
import { page, del } from "@/api/content/question";
import listMixin from '@/mixins/list';
export default {
    data() {
        return {
            // 查询参数
            query: {
                pageNo: 1,
                pageSize: 10
            }
        };
    },
    mixins: [listMixin],
    mounted() {

    },
    methods: {
        search() {
            this.loading = true;
            const params = {
                ...this.query,
            };
            page(params).then(({ code, result, message }) => {
                if (code == 200) {
                    this.tableData = result.records;
                    this.total = result.total;
                } else {
                    this.$message.error(message);
                }
                this.loading = false;
            });
        },
        handleAdd() {
            this.$router.push({ path: "/content/question/form" });
        },
        handleEdit(row) {
            this.$router.push({ path: "/content/question/form", query: { id: row.id } });
        },
        handleDelete(row) {
            this.$confirm("确定删除该常见问题吗？", "提示", { type: "warning" }).then(() => {
                del({ id: row.id }).then(({ code, message }) => {
                    if (code == 200) {
                        this.$message.success('删除成功');
                        this.search();
                    } else {
                        this.$message.error(message);
                    }
                });
            }).catch(() => { });
        }
    },
};
</script>